module.exports = __webpack_public_path__ + "img/caen.5a41ddfd.jpg";